import { atom } from 'recoil';

export const toggleMenuOpen = atom({
  key: 'toggleMenuOpen',
  default: false,
});
